"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubscriptionUsable = exports.SubscriptionStatus = void 0;
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["NONE"] = "none";
    SubscriptionStatus["ACTIVE"] = "active";
    SubscriptionStatus["CANCELED"] = "canceled";
    SubscriptionStatus["PAST_DUE"] = "past_due";
})(SubscriptionStatus || (exports.SubscriptionStatus = SubscriptionStatus = {}));
const isSubscriptionUsable = (status) => status === SubscriptionStatus.ACTIVE;
exports.isSubscriptionUsable = isSubscriptionUsable;
//# sourceMappingURL=subscriptionStatus.enum.js.map